import React, { createContext, useState, useContext } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('pt');

  const toggleLanguage = () => {
    setLanguage(prevLanguage => prevLanguage === 'pt' ? 'en' : 'pt');
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (Array.isArray(value)) {
        // Se value é array, tente converter k para número
        const idx = Number(k);
        if (!isNaN(idx) && value[idx] !== undefined) {
          value = value[idx];
        } else {
          console.warn(`Translation array index "${k}" not found for key "${key}" in language "${language}"`);
          return key;
        }
      } else if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        console.warn(`Translation key "${key}" not found for language "${language}"`);
        return key;
      }
    }
    return value;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
